// extracted by mini-css-extract-plugin
module.exports = {"individual":"AppLayout_individual__spBC7","navigationButton":"AppLayout_navigationButton__3CxjW","logo":"AppLayout_logo__3Jt2u"};